import React from 'react';

import { IClassNames, makeClassNames } from '../../utils/styles';
import './event-icon.scss';
import { LbEventType } from '../../configs/events';

export interface IEventIcon {
  icon?: string;
  borderColor?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
  type?: LbEventType;
}

const classNames = (isSkyPost?: boolean): IClassNames =>
  makeClassNames({
    EventIcon: ['event-icon', isSkyPost && 'event-icon--sky-post'],
  });

const EventIcon: React.FC<IEventIcon> = ({ icon, borderColor, backgroundColor, style, type }) => {
  const isSkyPost = type === LbEventType.SKY_POST;
  const cn = classNames(isSkyPost);

  return (
    <div className={cn.EventIcon} style={{ borderColor, backgroundColor, ...style }}>
      <img src={icon} alt="" loading="lazy" />
    </div>
  );
};

export default EventIcon;
